/* ============================================================
   FRUMMYS · theme.js
   ============================================================ */
(function(){
  /* --- Menú móvil --- */
  var btn = document.querySelector('.nav-toggle');
  var panel = document.getElementById('mobile-menu');
  if(btn && panel){
    function open(){ document.body.classList.add('menu-open'); btn.setAttribute('aria-expanded','true'); }
    function close(){ document.body.classList.remove('menu-open'); btn.setAttribute('aria-expanded','false'); }
    function toggle(){ document.body.classList.contains('menu-open') ? close() : open(); }
    btn.addEventListener('click', toggle);
    panel.addEventListener('click', function(e){ if(e.target.closest('a')) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
    var mq = window.matchMedia('(min-width:981px)');
    var onMq = function(e){ if(e.matches) close(); };
    if(mq.addEventListener){ mq.addEventListener('change', onMq); }
    else if(mq.addListener){ mq.addListener(onMq); }
  }
})();


/* --- Localizador de enlaces: prefija el idioma activo en enlaces internos --- */
(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if(root === '/'){
    var m = location.pathname.match(/^\/[a-z]{2}(?:-[a-zA-Z]{2})?(?=\/|$)/);
    if(m){ root = m[0] + '/'; } else { return; }
  }
  var pfx = root.replace(/\/$/, '');
  if(!pfx) return;
  var SEG = /^(pages|collections|products|blogs|cart|account|search|policies)(\/|$|\?|#)/;
  var SKIP = /^\/(cdn\/|checkout|services\/|apps\/|admin|payments\/|wpm|localization)/;
  function fix(scope){
    (scope.querySelectorAll ? scope : document).querySelectorAll('a[href^="/"]').forEach(function(a){
      var href = a.getAttribute('href');
      if(!href || href.indexOf('//') === 0 || SKIP.test(href)) return;
      if(href === pfx || href.indexOf(pfx + '/') === 0 || (href.indexOf(pfx + '?') === 0) || (href.indexOf(pfx + '#') === 0)) return;
      if(href.indexOf(pfx) === 0 && SEG.test(href.slice(pfx.length))){
        a.setAttribute('href', pfx + '/' + href.slice(pfx.length)); return;
      }
      if(SEG.test(href.slice(1))){ a.setAttribute('href', pfx + href); }
    });
  }
  fix(document);
  document.addEventListener('shopify:section:load', function(e){ fix(e.target); });
})();

/* --- Traducciones residuales EN (textos incrustados en secciones) --- */
(function(){
  var isEN = /^\/en(\/|$)/.test(location.pathname);
  if(!isEN && window.Shopify && Shopify.routes && Shopify.routes.root && Shopify.routes.root.indexOf('/en') === 0) isEN = true;
  if(!isEN) return;
  function tr(s){
    return s.replace('Ahorra hasta', 'Save up to').replace('Ahorra un', 'Save').replace(/(\d+)\s+productos/, '$1 products');
  }
  function fixTexts(){
    document.querySelectorAll('.products-h2').forEach(function(el){
      if(/^Todos los/.test(el.textContent.trim())) el.innerHTML = 'All <em>products.</em>';
    });
    document.querySelectorAll('.section-eyebrow').forEach(function(el){
      var t = tr(el.textContent); if(t !== el.textContent) el.textContent = t;
    });
    document.querySelectorAll('.pc-price small').forEach(function(el){
      if(el.textContent.trim() === 'desde') el.textContent = 'from';
    });
    document.querySelectorAll('h4').forEach(function(el){
      if(el.textContent.trim() === 'Ingredientes') el.textContent = 'Ingredients';
    });
    document.querySelectorAll('.nutrition-note, [class*=nutri]').forEach(function(el){
      if(el.textContent.indexOf('* Contiene az') === 0) el.textContent = '* Contains naturally occurring fruit sugars. No added sugars.';
    });
    document.querySelectorAll('[data-subtag]').forEach(function(el){
      var t = tr(el.textContent); if(t !== el.textContent) el.textContent = t;
    });
  }
  fixTexts();
  document.querySelectorAll('[data-subtag]').forEach(function(el){
    if(!window.MutationObserver) return;
    new MutationObserver(function(){
      var t = tr(el.textContent); if(t !== el.textContent) el.textContent = t;
    }).observe(el, {childList:true, characterData:true, subtree:true});
  });
})();
